import React from "react";
import { Select } from "antd";
import { IRestaurant } from "../../../../types/items";

const { Option } = Select;

type TProps = {
  restaurants: IRestaurant[];
  value: string;
  setRestaurant: React.Dispatch<React.SetStateAction<string>>;
  lang: string;
};

export const SelectRestaurant: React.FC<TProps> = ({
  restaurants,
  value,
  setRestaurant,
  lang,
}) => {
  const onChange = (val: string) => {
    setRestaurant(val);
  };

  return (
    <Select
      value={value || undefined}
      onChange={onChange}
      style={{ width: 240 }}
      placeholder="Оберіть ресторан"
    >
      {restaurants?.map((opt) => (
        <Option key={opt._id} value={opt._id}>
          {Array.isArray(opt.title)
            ? opt.title.find((t) => t.lang === lang)?.value ||
              opt.title[0]?.value
            : opt.title}
        </Option>
      ))}
    </Select>
  );
};
